export const DELETE_CANDIDATE_DATA_REQUEST = 'GDPRConfirmationPage/DELETE_CANDIDATE_DATA_REQUEST';
export const DELETE_CANDIDATE_DATA_SUCCESS = 'GDPRConfirmationPage/DELETE_CANDIDATE_DATA_SUCCESS';
export const DELETE_CANDIDATE_DATA_FAILURE = 'GDPRConfirmationPage/DELETE_CANDIDATE_DATA_FAILURE ';
